import { render, staticRenderFns } from "./SignInH5New.vue?vue&type=template&id=54729464&scoped=true&"
import script from "./SignInH5New.vue?vue&type=script&lang=js&"
export * from "./SignInH5New.vue?vue&type=script&lang=js&"
import style0 from "./SignInH5New.vue?vue&type=style&index=0&id=54729464&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54729464",
  null
  
)

export default component.exports